// Static media (images, videos, gallery) keyed by project id — kept in code since CMS only manages text.
export const WORK_MEDIA = {
  "expo-2020": {
    image: "/media/img/d2020-cityscape-3.jpg",
    previewVideo: "/media/video/d2020-cityscape.mp4",
    previewPoster: "/media/img/d2020-cityscape-3.jpg",
    videos: [{ src: "/media/video/d2020-cityscape.mp4", title: "District 2020 — Cityscape 2019" }],
    gallery: [
      "/media/img/d2020-cityscape-1.jpg",
      "/media/img/d2020-cityscape-5.jpg",
      "/media/img/d2020-cityscape-10.jpg",
      "/media/img/d2020-app.jpg",
      "/media/img/ms-teams-79.jpg",
    ],
    galleryVideos: [{ src: "/media/video/d2020-ipad.mp4", title: "District 2020 — iPad App" }],
  },
  "uk-gov": {
    image: "/media/img/uk-gov-mipim.jpg",
    previewVideo: "/media/video/mipim-2019.mp4",
    previewPoster: "/media/img/uk-gov-mipim.jpg",
    videos: [{ src: "/media/video/mipim-2019.mp4", title: "MIPIM 2019 · Digital Partnership" }],
    gallery: [
      "/media/img/minister.jpg",
      "/media/img/uk-gov-mipim.jpg",
      "/media/img/mipim-team.jpg",
      "/media/img/mipim.jpg",
    ],
    galleryVideos: [],
  },
  "grohe": {
    image: "/media/img/grohe.jpg",
    previewVideo: "/media/video/grohe-plus.mp4",
    previewPoster: "/media/img/grohe.jpg",
    videos: [{ src: "/media/video/grohe-plus.mp4", title: "GROHE Plus Range" }],
    gallery: ["/media/img/grohe.jpg"],
    galleryVideos: [],
  },
  "scottish-enterprise": {
    image: "/media/img/women-in-biz.jpg",
    previewVideo: null,
    previewPoster: "/media/img/women-in-biz.jpg",
    videos: [],
    gallery: [
      "/media/img/women-in-biz.jpg",
      "/media/img/event-1.jpg",
      "/media/img/event-2.jpg",
    ],
    galleryVideos: [],
  },
};
